import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  Typography,
  DialogActions,
  Button
} from '@mui/material';

function AcceptAllReviewsDialog({
  handleClose,
  isOpen,
  handleAcceptAllReviews
}) {

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
    >
      <Box sx={{ padding: '20px' }}>
        <Typography variant="h6">Accept ALL Encounter Reviews</Typography>
        <Typography variant="body">
          Are you sure you want to accept all encounter reviews? This operation
          may take a while, and it CANNOT be undone.
        </Typography>
      </Box>
      <DialogActions>
        <Button
          onClick={() => {
            handleAcceptAllReviews()
              .then(result => {
                handleClose();
                if (result > 0) {
                  // refresh for latest kpis if anything was actually accepted
                  alert(`Accepted ${result} review(s). Now refreshing page.`);
                  window.location.reload();
                }
              });
          }}
        >
          Ok
        </Button>
        <Button onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AcceptAllReviewsDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleAcceptAllReviews: PropTypes.func.isRequired
};

export { AcceptAllReviewsDialog };
